// Admin va partner panellarida bayt-bayt bir xil (tests/voucher-print.mjs).

export const PRINT_ROOT = 'xsib-voucher-print'

/**
 * Varaqdagi rasmlar (logotip) yuklanguncha kutadi. Rasm ochilmasa `false` —
 * logotipsiz yuzlab karta chop etilmasin.
 */
export async function imagesReady(): Promise<boolean> {
  const images = Array.from(document.querySelectorAll<HTMLImageElement>(`.${PRINT_ROOT} img`))
  const results = await Promise.all(
    images.map((image) =>
      image.decode().then(
        () => true,
        () => false,
      ),
    ),
  )
  return results.every(Boolean)
}
